import "../styles/our-story.css";
import "../styles/section-chef.css";

import { useState } from "react";

import { CircularProgress } from "@mui/material";
import { useEffect } from "react";

import OurStoryBanner from "./our-story-banner";
import PowerHomeMadeMeal from "./power-home-made-meal";

const SelectAboutUs = (props) => {
  const { lang } = props;

  const [load, _] = useState(false);

  useEffect(() => {}, []);

  return (
    <div
    // className="section-chef-menu-right-profil"
    >
      <div>
        {load && <CircularProgress size={40} />}

        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <div
            style={{
              maxWidth: "2800px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            {" "}
            {/*utilisation du maxwidth pour eviter des comportements inattendu avec les tailles des differents éléments (img, div etc) */}
            <PowerHomeMadeMeal lang={lang} />
            <OurStoryBanner lang={lang} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectAboutUs;
